import { render, staticRenderFns } from "./TicketChips.vue?vue&type=template&id=68be38bf&scoped=true&"
import script from "./TicketChips.vue?vue&type=script&lang=js&"
export * from "./TicketChips.vue?vue&type=script&lang=js&"
import style0 from "./TicketChips.vue?vue&type=style&index=0&id=68be38bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be38bf",
  null
  
)

component.options.__file = "TicketChips.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!/src/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
